import script from "./GiftSend.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftSend.vue?vue&type=script&setup=true&lang=js"

import "./GiftSend.vue?vue&type=style&index=0&id=4a3ffb58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3ffb58"]])

export default __exports__